import { FC } from 'react';
import {
  EdgeProps,
  EdgeText,
  getBezierPath,
  getEdgeCenter,
  getMarkerEnd,
} from 'react-flow-renderer';
import { ELEMENT_TYPE } from '../../constants/diagram';
import { useAppDispatch } from '../../hooks';
import { removeDiagramElements } from '../../redux/slices/diagramSlice';
import { cloneObject } from '../../utils';

const Edge: FC<EdgeProps> = ({
  id,
  source,
  target,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  arrowHeadType,
  markerEndId,
}) => {
  const dispatch = useAppDispatch();
  const edgePath = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });
  const markerEnd = getMarkerEnd(arrowHeadType, markerEndId);
  const [centerX, centerY] = getEdgeCenter({
    sourceX,
    sourceY,
    targetX,
    targetY,
  });

  const urlElements = window.location.href.split('/');

  const onDeleteEdge = () => {
    if (urlElements[4] === 'editor') {
      const edgeElement = cloneObject({});
      edgeElement.type = ELEMENT_TYPE.EDGE;
      edgeElement.id = id;
      edgeElement.source = source;
      edgeElement.target = target;
      dispatch(removeDiagramElements([edgeElement]));
    }
  };

  return (
    <>
      <path
        id={id}
        className="react-flow__edge-path"
        d={edgePath}
        markerEnd={markerEnd}
      />
      {urlElements[4] === 'editor' ? (
        <EdgeText
          onClick={onDeleteEdge}
          x={centerX}
          y={centerY}
          label="X"
          labelStyle={{
            fontSize: '12px',
            fill: 'white',
            fontWeight: 'bold',
          }}
          labelShowBg
          labelBgStyle={{ fill: 'red', cursor: 'pointer' }}
          labelBgPadding={[6, 2]}
          labelBgBorderRadius={20}
        />
      ) : null}
    </>
  );
};

export default Edge;
